import React from 'react';
import { useRoutes, RouteObject } from 'react-router-dom';
import { WorkspaceProvider } from '@/contexts/WorkspaceContext';
import { WorkspaceErrorBoundary } from '@/components/WorkspaceErrorBoundary';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import Dashboard from '@/pages/Dashboard';

function WorkspaceRouteWrapper() {
  return (
    <WorkspaceErrorBoundary>
      <WorkspaceProvider>
        <DashboardLayout />
      </WorkspaceProvider>
    </WorkspaceErrorBoundary>
  );
}

export default function WorkspaceRoutes() {
  const routes: RouteObject[] = [
    {
      path: ':workspaceId/*',
      element: <WorkspaceRouteWrapper />,
    },
    {
      // Handle plain /dashboard by using WorkspaceRouteWrapper, which reads workspaceId from session via context
      path: '/dashboard',
      element: <WorkspaceRouteWrapper />,
      children: [
        { index: true, element: <Dashboard /> },
      ],
    },
  ];

  return useRoutes(routes);
}
